import { render } from "./MCACloudFaq.vue?vue&type=template&id=a4799340"
import script from "./MCACloudFaq.vue?vue&type=script&lang=js"
export * from "./MCACloudFaq.vue?vue&type=script&lang=js"

import "./MCACloudFaq.vue?vue&type=style&index=0&id=a4799340&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__